import { render, staticRenderFns } from "./fusePurchaseRequestHead.vue?vue&type=template&id=5b938c10&scoped=true"
import script from "./fusePurchaseRequestHead.vue?vue&type=script&lang=js"
export * from "./fusePurchaseRequestHead.vue?vue&type=script&lang=js"
import style0 from "./fusePurchaseRequestHead.vue?vue&type=style&index=0&id=5b938c10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b938c10",
  null
  
)

export default component.exports